// VITE_SPECKLE_CONNECTOR_URL is the connector-facing server address, configured per environment and
// historically written as a bare hostname ("api-dev.realtimelca.com"). Both the Speckle Settings row
// and its copy button need a value that works when pasted into the connector or a browser, so the
// scheme is added in one place rather than at either call site. A value that already carries a scheme
// is left as it is — an environment deliberately served over http:// must stay on http://.
const SCHEME_PREFIX = /^[a-z][a-z0-9+.-]*:\/\//i;

// Returns "" when nothing is configured, so callers can hide the row instead of showing a broken URL.
export const normalizeSpeckleServerUrl = (rawServerUrl: string | undefined): string => {
  // Trailing slashes are dropped so the displayed and copied value is the plain server address.
  const serverUrl = rawServerUrl?.trim().replace(/\/+$/, "") ?? "";
  if (!serverUrl) return "";

  return SCHEME_PREFIX.test(serverUrl) ? serverUrl : `https://${serverUrl}`;
};
